export default __webpack_public_path__ + "static/media/Q8_3_resized.c2fe1ae2.jpg";